const endpointCep = "https://viacep.com.br/ws/{{cep}}/json";
const camposCep = ["address1", "address2", "city", "state"];
const endpointCnpj = "/tools/consultar-cnpj/{{cnpj}}";
const camposCnpj = [
    "companyname",
    "postcode",
    "address1",
    "address2",
    "city",
    "state",
];
const camposMask = {
    cep: {
        el: document.querySelector("#inputPostcode"),
        mask: ["99999-999", "99999-999"],
    },
    telefone: {
        el: document.querySelector("#inputPhone"),
        mask: ["(99) 9999-9999", "(99) 99999-9999"],
    },
    cnpj_cpf: {
        el: document.querySelector(".cnpj-cpf #customfield153"),
        mask: ["999.999.999-99", "99.999.999/9999-99"],
        container: document.querySelector('.cnpj-cpf')
    },
    cnpj: {
        el: document.querySelector(".p-juridica #customfield153"),
        mask: ["99.999.999/9999-99", "99.999.999/9999-99"],
        container: document.querySelector('.tipo-cliente.p-juridica')
    },
    cpf: {
        el: document.querySelector(".tipo-cliente.p-fisica #customfield154"),
        mask: ["999.999.999-99", "999.999.999-99"],
        container: document.querySelector('.tipo-cliente.p-fisica')
    },
    nomeEmpresa: {
        el: document.querySelector('.tipo-cliente.nome-empresa input'),
        container: document.querySelector('.tipo-cliente.nome-empresa'),
    }
}

const estados = [
    { "nome": "Acre", "sigla": "AC" },
    { "nome": "Alagoas", "sigla": "AL" },
    { "nome": "Amapá", "sigla": "AP" },
    { "nome": "Amazonas", "sigla": "AM" },
    { "nome": "Bahia", "sigla": "BA" },
    { "nome": "Ceará", "sigla": "CE" },
    { "nome": "Distrito Federal", "sigla": "DF" },
    { "nome": "Espírito Santo", "sigla": "ES" },
    { "nome": "Goiás", "sigla": "GO" },
    { "nome": "Maranhão", "sigla": "MA" },
    { "nome": "Mato Grosso", "sigla": "MT" },
    { "nome": "Mato Grosso do Sul", "sigla": "MS" },
    { "nome": "Minas Gerais", "sigla": "MG" },
    { "nome": "Pará", "sigla": "PA" },
    { "nome": "Paraíba", "sigla": "PB" },
    { "nome": "Paraná", "sigla": "PR" },
    { "nome": "Pernambuco", "sigla": "PE" },
    { "nome": "Piauí", "sigla": "PI" },
    { "nome": "Rio de Janeiro", "sigla": "RJ" },
    { "nome": "Rio Grande do Norte", "sigla": "RN" },
    { "nome": "Rio Grande do Sul", "sigla": "RS" },
    { "nome": "Rondônia", "sigla": "RO" },
    { "nome": "Roraima", "sigla": "RR" },
    { "nome": "Santa Catarina", "sigla": "SC" },
    { "nome": "São Paulo", "sigla": "SP" },
    { "nome": "Sergipe", "sigla": "SE" },
    { "nome": "Tocantins", "sigla": "TO" }
]

export { camposMask, endpointCep, camposCep, endpointCnpj, camposCnpj, estados }